/* eslint-disable no-template-curly-in-string */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-restricted-syntax */
import { CheckOutlined, EditOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Alert,
  Button,
  Col,
  Input,
  message as messagePopUp,
  Modal,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import DateTimePicker from "react-datetime-picker/dist/entry.nostyle";
import Emoji from "react-emoji-render";
import Highlighter from "react-highlight-words";
import { useDispatch } from "react-redux";

import { getAllUsers } from "../../lib/queries";
import { getSupaClient, getWorkspace } from "../../lib/supabase";
import { setReplyModalStatus } from "../../redux/actions";
import { SlackEditor, SlackEditorPreview } from "../TextEditor/SlackEditor";

const moment = require("moment-timezone");

const defaultTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";
const { TextArea } = Input;
const { Option } = Select;
const timezones = moment.tz.names();

const SendDM = (props) => {
  // props.sendNow (boolean): if true, set scheduled time to now, else show datepicker
  // props.closeModal should be a function in the parent that closes this modal
  // props.selectedUsers should be a list of selected users
  // props.selectableUsers should be a list of users that are in the table where you're using SendDM. If not passed, SendDM will attempt to fetch in getActiveUsers.
  // props.hideSelectMembers to hide the select member
  const supabase = getSupaClient();
  const teamId = localStorage.getItem("team-id");
  const slackId = localStorage.getItem("slack-id");
  const workspace = getWorkspace(supabase);
  const [sendNow, setSendNow] = useState(props.sendNow);
  const [message, setMessage] = useState({});
  const [isSending, setIsSending] = useState(false);
  const [previewMessages, setPreviewMessages] = useState([]);
  const [userModalVisible, setIsModalVisible] = useState(false);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [memberIds, setMemberIds] = useState("");
  const [memberEmails, setMemberEmails] = useState("");
  const [memberEmailError, setMemberEmailError] = useState({
    error: false,
    emails: [],
  });

  const [activeUsers, setActiveUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [maxSelectedUsers, setMaxSelectedUsers] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [dateTimeObj, setDateTimeObj] = useState(new Date());
  const [selectedTimezone, setSelectedTimezone] = useState("");
  const [previewError, setPreviewError] = useState("");
  const [memberIdError, setMemberIdError] = useState({
    error: false,
    ids: [],
  });
  const [selectorType, setSelectorType] = useState("slackIds");
  const [memberSelectorModalVisible, setMemberSelectorModalVisible] =
    useState(false);

  const [teammates, setTeammates] = useState([]);
  const [selectedTeammate, setSelectedTeammate] = useState("");

  /**
   * Load teammates from the users table.
   */
  const loadTeammates = async () => {
    const { data, error } = await supabase
      .from("users")
      .select("slack_id, name")
      .filter("team", "eq", teamId);

    if (data && data[0]) {
      data.push({ name: "bot", slack_id: "bot" });
      setTeammates(data);
    }

    if (error) {
      console.log("Error loading teammates:", error);
    }
  };

  const dispatch = useDispatch();

  const getActiveUsers = async () => {
    if (props.selectableUsers) {
      setActiveUsers(props.selectableUsers);
    } else {
      const startTime = "2020-12-01T00:00:00Z";
      const endTime = moment().format(defaultTimeFormat);
      const data = await getAllUsers(startTime, endTime, teamId);
      const users = data.map((result) => {
        const key = result.user_id;
        const email = result.user_email;
        result.key = key;
        result.email = email;
        return result;
      });
      setActiveUsers(users);
    }
  };

  const loadPageData = async () => {
    await getActiveUsers();
  };

  useEffect(() => {
    loadTeammates();
    loadPageData();
    setSelectedTimezone(moment.tz.guess());
    setSelectedTeammate(slackId);
  }, []);

  const hidePreviewModal = () => {
    setPreviewMessages([]);
    setPreviewModalVisible(false);
    dispatch(setReplyModalStatus(true));
  };

  const replaceHTMLTokens = (html, userFirstName, userId, userName) => {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(html, "text/html");
    let spans = htmlDoc.querySelector(`span[data-denotation-char="{{"]`);

    // find and replace {{first_name}} and {{@_mention}} tokens
    while (spans) {
      const denotation = spans.getAttribute("data-denotation-char");
      if (denotation === "{{") {
        const id = spans.getAttribute("data-id");
        // replace {{first_name}} token
        if (id === "first_name") {
          const firstNameNode = document.createTextNode(`${userFirstName}`);
          spans.parentNode.replaceChild(firstNameNode, spans);
        }
        // replace {{@_mention}} token by constructing quill-mention span for given user
        if (id === "@_mention") {
          const mentionOuterSpan = document.createElement("span");
          mentionOuterSpan.className = "mention";
          mentionOuterSpan.setAttribute("data-denotation-char", " @");
          mentionOuterSpan.setAttribute("data-id", userId);
          mentionOuterSpan.setAttribute("data-value", userName);
          const mentionInnerSpan = document.createElement("span");
          mentionInnerSpan.setAttribute("contenteditable", false);
          const userNameTextNode = document.createTextNode(`${userName}`);
          const innerMostSpan = document.createElement("span");
          innerMostSpan.className = "ql-mention-denotation-char";
          innerMostSpan.innerHTML = " @";
          mentionInnerSpan.appendChild(innerMostSpan);
          mentionInnerSpan.appendChild(userNameTextNode);
          mentionOuterSpan.appendChild(mentionInnerSpan);
          spans.parentNode.replaceChild(mentionOuterSpan, spans);
        }
      }
      spans = htmlDoc.querySelector(`span[data-denotation-char="{{"]`);
    }

    return htmlDoc.documentElement.outerHTML;
  };

  // Check if user identifier is email or id
  const checkEmail = (idSample) => {
    if (idSample.includes("@")) {
      return "email";
    }
    return "id";
  };

  const formatMessages = () => {
    const messages = [];
    let recipients = [];
    if (props.selectedUsers) recipients = props.selectedUsers;
    else recipients = selectedUsers;
    const idSample = recipients[0];
    const idType = checkEmail(idSample);
    for (const userId of recipients) {
      let user;
      if (idType === "email") {
        user = activeUsers.find((x) => x.user_email === userId);
      } else {
        user = activeUsers.find((x) => x.key === userId);
      }
      if (user) {
        const userFirstName = user.user_name.split(" ")[0];
        const replacedHTML = replaceHTMLTokens(
          message.html,
          userFirstName,
          user.key,
          user.user_name
        );
        messages.push({
          user: user.user_name,
          html: replacedHTML,
          text: message.text
            .replaceAll("{{first_name}}", userFirstName)
            .replaceAll("{{@_mention}}", `**@${user.user_name}**`),
          slack_mrkdwn: message.slack_mrkdwn
            .replaceAll("{{first_name}}", userFirstName)
            .replaceAll("{{@_mention}}", `<@${user.key}>`),
          userId: user.key,
          isEdit: false,
        });
      }
    }
    return messages;
  };

  // formatPreviewMessages: This function is being used to format messages after edited preview

  const formatPreviewMessages = () => {
    let messages = [];
    let obj = {};
    messages = previewMessages.map((item) => {
      let user = activeUsers.find((x) => x.key === item.userId);
      if (!user) user = activeUsers.find((x) => x.email === item.userId);
      if (user) {
        const userFirstName = user.user_name.split(" ")[0];
        const replacedHTML = replaceHTMLTokens(
          item.html,
          userFirstName,
          user.key,
          user.user_name
        );
        obj = {
          ...item,
          html: replacedHTML,
          text: item.text
            .replaceAll("{{first_name}}", userFirstName)
            .replaceAll("{{@_mention}}", `**@${user.user_name}**`),
          slack_mrkdwn: item.slack_mrkdwn
            .replaceAll("{{first_name}}", userFirstName)
            .replaceAll("{{@_mention}}", `<@${user.key}>`),
        };
      }
      return obj;
    });

    return messages;
  };

  const getScheduledTime = () => {
    let scheduledTime = null;
    if (!sendNow) {
      const timeStr = moment(dateTimeObj).format("YYYY-MM-DD HH:mm A");
      scheduledTime = moment.tz(
        timeStr,
        "YYYY-MM-DD HH:mm A",
        selectedTimezone
      );
    } else {
      const now = moment().add(2, "m").set("second", 0).set("millisecond", 0);
      scheduledTime = moment.tz(now, selectedTimezone);
    }
    return scheduledTime;
  };

  // Take a list of emails and return an list of the corresponding user ids
  const getIdsFromEmails = (emails) => {
    const userIds = [];
    for (const email of emails) {
      const user = activeUsers.find((item) => item.email === email);
      userIds.push(user.key);
    }
    return userIds;
  };

  const scheduleDMs = async () => {
    setIsSending(true);
    const messages = await formatPreviewMessages();
    let payload;
    const recipients = props.selectedUsers
      ? props.selectedUsers
      : selectedUsers;

    // Check if selectedUsers has emails only
    const idType = checkEmail(recipients[0]);
    // If emails only, get the corresponding user ids
    // and create a payload with these ids
    if (idType === "email") {
      const userIds = getIdsFromEmails(recipients);
      payload = {
        recipients: userIds,
        messages,
        sender: selectedTeammate,
        team: teamId,
      };
    } else {
      payload = {
        recipients,
        messages,
        sender: selectedTeammate,
        team: teamId,
      };
    }

    const scheduledTimeLocal = getScheduledTime().format();
    const scheduledTimeUTC = getScheduledTime().utc().format();
    const { data, error } = await supabase.from("scheduled_tasks").insert({
      scheduled_time_utc: scheduledTimeUTC,
      scheduled_time_local: scheduledTimeLocal,
      timezone: selectedTimezone,
      team: teamId,
      run_function: "sendDMs",
      created_by: slackId,
      // sender column is an FK to users table, so we can't save "bot"
      // sender column used to display sender in scheduled messages table
      sender: selectedTeammate === "bot" ? null : selectedTeammate,
      payload,
      workspace,
    });
    if (error) {
      console.log("Error in scheduleDMs:", error);
      messagePopUp.warning("Message sending failed. Please try again");
      window.analytics.track("Message failed", {
        slackId,
        recipients: props.selectedUsers
          ? props.selectedUsers.length
          : selectedUsers.length,
      });
    }
    if (data) {
      setMessage({});
      messagePopUp.success("Message scheduled!");
      window.analytics.track("Message scheduled", {
        slackId,
        recipients: props.selectedUsers
          ? props.selectedUsers.length
          : selectedUsers.length,
      });
      setSelectedUsers([]);
      setIsSending(false);
      hidePreviewModal();
      if (props.closeModal) {
        props.closeModal();
      }
    }
  };

  const showUserSelectModal = () => {
    setIsModalVisible(true);
  };

  const hideUserSelectModal = () => {
    setIsModalVisible(false);
  };

  const saveMemberEmail = () => {
    const enteredMemberEmails = memberEmails
      .replace(/,\s+/g, ",")
      .split(/[\n,\s+]/);
    const errorEmails = [];
    const verifiedUsers = enteredMemberEmails.flatMap((email) => {
      if (!activeUsers.some((user) => user.user_email === email)) {
        errorEmails.push(email);
        return [];
      }
      return email;
    });
    if (errorEmails.length > 0) {
      setMemberEmailError({ error: true, emails: errorEmails });
    } else {
      setMemberEmailError({ error: false, emails: [] });
      setSelectedUsers(verifiedUsers);
      setMemberSelectorModalVisible(false);
    }
  };

  const hideEnterMemberSelectorModal = () => {
    setMemberSelectorModalVisible(false);
  };

  const showEnterMemberSelectorModal = () => {
    setMemberSelectorModalVisible(true);
  };

  const saveMemberId = () => {
    // ADD here
    const enteredMemberIds = memberIds.replace(/,\s+/g, ",").split(/[\n,\s+]/);
    const errorIds = [];
    const verifiedUsers = enteredMemberIds.flatMap((id) => {
      if (!activeUsers.some((user) => user.user_id === id)) {
        errorIds.push(id);
        return [];
      }
      return id;
    });
    if (errorIds.length > 0) {
      setMemberIdError({ error: true, ids: errorIds });
    } else {
      setMemberIdError({ error: false, ids: [] });
      setSelectedUsers(verifiedUsers);
      setMemberSelectorModalVisible(false);
    }
  };

  const handleIdType = (e) => {
    setSelectorType(e.target.value);
  };

  const handleDisabled = () => {
    if (selectorType === "emails") {
      if (memberEmails.length === 0) return true;
      return false;
    }
    if (selectorType === "slackIds") {
      if (memberIds.length === 0) return true;
      return false;
    }
    return true;
  };

  const showPreview = async () => {
    if (sendNow) {
      setPreviewError("");
      const messages = await formatMessages();
      setPreviewMessages(messages);
      setPreviewModalVisible(true);
      dispatch(setReplyModalStatus(false));
    } else {
      const scheduledTime = getScheduledTime();
      if (scheduledTime < moment.now()) {
        setPreviewError("Please select a time in the future!");
      } else {
        setPreviewError("");
        const messages = await formatMessages();
        setPreviewMessages(messages);
        setPreviewModalVisible(true);
        dispatch(setReplyModalStatus(false));
      }
    }
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            // eslint-disable-next-line no-unused-vars
            const searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{ fontSize: 20, color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) => {
      return record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "";
    },
    onFilterDropdownVisibleChange: () => {},
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const activeUserscolumns = [
    {
      title: "User",
      dataIndex: "user_name",
      ...getColumnSearchProps("user_name"),
      filters: [
        { text: "Admin", value: true },
        { text: "Non-admin", value: false },
      ],
    },
    {
      title: "Total actions taken",
      dataIndex: "total_count",
      key: "total_count",
      sorter: (a, b) => {
        return a.total_count - b.total_count;
      },
      sortDirections: ["descend", "ascend"],
    },
  ];

  // EditPreviewMessage: This function is being used to open the editor for specific user

  const EditPreviewMessage = (record) => {
    const tempArray = previewMessages.map((item) => {
      if (record.userId === item.userId) {
        item.isEdit = true;
      }
      return item;
    });
    setPreviewMessages(tempArray);
  };

  // handleChangeEditMessage: This function is being used to save the edited message for specific user

  const handleChangeEditMessage = (record) => {
    const tempArray = previewMessages.map((item) => {
      if (record.userId === item.userId) {
        item = record;
        item.isEdit = true;
      }
      return item;
    });
    setPreviewMessages(tempArray);
    formatMessages();
  };

  // EditPreviewMessage: This function is being used to close the editor for specific user

  const handleCloseEditor = async (record) => {
    const tempArray = previewMessages.map((item) => {
      if (record.userId === item.userId) {
        item.isEdit = false;
      }
      return item;
    });

    setPreviewMessages(tempArray);

    const messages = await formatPreviewMessages();
    setPreviewMessages(messages);
  };

  const previewMessagesColumns = [
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      width: "20%",
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      width: "70%",
      render: (text, record) =>
        record.isEdit ? (
          <SlackEditor onChange={handleChangeEditMessage} value={record} />
        ) : (
          <SlackEditorPreview message={record} />
        ),
    },
    {
      title: "Edit",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      render: (text, record) => (
        <>
          {!record.isEdit ? (
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={() => EditPreviewMessage(record)}
            />
          ) : (
            <Button
              type="primary"
              icon={<CheckOutlined />}
              onClick={() => handleCloseEditor(record)}
            />
          )}
        </>
      ),
    },
  ];

  const onSelectChange = (newSelections) => {
    setSelectedUsers(newSelections.slice(0, 100));
  };

  const rowSelection = {
    selectedRowKeys: selectedUsers,
    onChange: onSelectChange,
  };

  const hasSelected = selectedUsers.length > 0;

  const onChangeMemberIds = (e) => {
    setMemberIds(e.target.value);
  };

  const onChangeMemberEmails = (e) => {
    setMemberEmails(e.target.value);
  };

  return (
    <div>
      <div style={{ width: "100%", height: "100%" }}>
        <Space direction="vertical">
          {props.hideSelectMembers ? (
            ""
          ) : (
            <>
              <Row>Select members</Row>

              <Row>
                <Space>
                  <Button
                    key="select"
                    type="primary"
                    onClick={showUserSelectModal}
                  >
                    Select members
                  </Button>{" "}
                  or
                  <Button key="select" onClick={showEnterMemberSelectorModal}>
                    Enter Slack Ids / Emails
                  </Button>{" "}
                </Space>
              </Row>
              <Row>
                <p>
                  {hasSelected
                    ? `Selected ${selectedUsers.length} users (max ${maxSelectedUsers} users). `
                    : `No users selected (max ${maxSelectedUsers} users). `}
                </p>
              </Row>
            </>
          )}

          <Row>
            <div className="flex flex-col grow">
              <div className="mb-2">Compose your message:</div>

              <SlackEditor
                onChange={setMessage}
                value={{ html: message.html || "Hey!😀" }}
              />

              <div className="w-full mt-1 pr-12 text-gray-500">
                Tip: You can use {"{{first_name}}"} and {"{{@_mention}}"} to
                personalize!
                {/* <Popover
                  content={
                    <div style={{ width: 300 }}>
                      <p>
                        We support Markdown formatting.{" "}
                        <a
                          target="_blank"
                          href="https://www.markdownguide.org/basic-syntax/"
                          rel="noreferrer"
                        >
                          (What is markdown?)
                        </a>
                      </p>
                      <p>
                        E.g. To create a link, enclose the link text in brackets
                        (e.g., [Duck Duck Go]) and then follow it immediately
                        with the URL in parentheses (e.g.,
                        (https://duckduckgo.com)). You can use the options in
                        the text box to help you do this automatically, and you
                        will see a preview.{" "}
                      </p>
                      <p>
                        For emojis, use slack emoji formatting. E.g. type :tada:
                        for <Emoji text=":tada:" />{" "}
                      </p>
                    </div>
                  }
                >
                  <span style={{ color: "#4ca3ee" }}> (More formatting?) </span>
                </Popover> */}
              </div>
            </div>
          </Row>

          <Row>
            <Space>
              <span>Send As: </span>
              <Select
                style={{ width: 200, marginLeft: 10 }}
                placeholder="Select user to send as"
                onSelect={setSelectedTeammate}
                value={selectedTeammate || null}
              >
                {teammates.map(function (teammate) {
                  return (
                    <Option
                      key={teammate.slack_id}
                      value={teammate.slack_id}
                      name={teammate.name}
                    >
                      {teammate.name}
                    </Option>
                  );
                })}
              </Select>
            </Space>
          </Row>

          <div className="font-bold mt-2">Choose when to send:</div>

          <Row>
            <Space>
              <Radio.Group
                onChange={(val) => setSendNow(val.target.value)}
                value={sendNow}
              >
                <Radio value>Send now</Radio>
                <Radio value={false}>Send later</Radio>
              </Radio.Group>
            </Space>
          </Row>

          {sendNow ? null : (
            <div className="flex flex-row">
              <DateTimePicker
                style={{ marginBottom: 5, width: "auto" }}
                onChange={setDateTimeObj}
                value={dateTimeObj}
                disableClock
              />
              <Select
                placeholder="Timezone"
                onChange={setSelectedTimezone}
                showSearch
                style={{ width: 160, marginLeft: 10 }}
                value={selectedTimezone}
              >
                {timezones.map(function (val) {
                  return <Option value={val}>{val}</Option>;
                })}
              </Select>
            </div>
          )}

          <Row className="mt-10">
            <Col span={12} offset={4} style={{ textAlign: "center" }}>
              {previewError ? (
                <Alert message={previewError} type="error" display />
              ) : null}
            </Col>
            <Col span={8} style={{ textAlign: "right" }}>
              <Tooltip title="Click here to preview - messages won't be send yet.">
                {
                  // eslint-disable-next-line no-bitwise
                  (selectedUsers.length > 0 || props.selectedUsers != null) &
                  (message.text !== undefined && message.text !== "") &
                  (selectedTeammate != null) ? (
                    <Button key="submit" type="primary" onClick={showPreview}>
                      Preview
                    </Button>
                  ) : (
                    <Button key="submit" type="primary" disabled>
                      Preview
                    </Button>
                  )
                }
              </Tooltip>
            </Col>
          </Row>
        </Space>
      </div>

      <Modal
        width={600}
        title="Enter member Slack IDs / emails (comma, whitespace or newline separated) "
        style={{ top: 40, right: 10 }}
        visible={memberSelectorModalVisible}
        onCancel={hideEnterMemberSelectorModal}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={selectorType === "emails" ? saveMemberEmail : saveMemberId}
            disabled={handleDisabled()}
          >
            Ok
          </Button>,
        ]}
      >
        <div style={{ marginBottom: "20px" }}>
          <Radio.Group onChange={handleIdType} value={selectorType}>
            <Radio value="slackIds">Slack IDs</Radio>
            <Radio value="emails">Emails</Radio>
          </Radio.Group>
        </div>
        {selectorType === "emails" ? (
          <TextArea
            rows={3}
            onChange={onChangeMemberEmails}
            value={memberEmails}
          />
        ) : null}
        {selectorType === "slackIds" ? (
          <TextArea rows={3} onChange={onChangeMemberIds} value={memberIds} />
        ) : null}
        {memberEmailError.error ? (
          <Alert
            style={{ marginTop: "10px" }}
            message={`We couldn't find the following member emails in your workspace:
             ${memberEmailError.emails} | Please fix or remove these emails to proceed.`}
            type="error"
          />
        ) : (
          ""
        )}
        {memberIdError.error ? (
          <Alert
            style={{ marginTop: "10px" }}
            message={`We couldn't find the following member IDs in your workspace:
             ${memberIdError.ids} | Please fix or remove these IDs to proceed.`}
            type="error"
          />
        ) : (
          ""
        )}
      </Modal>

      <Modal
        width={600}
        title="Select members "
        style={{ top: 40, right: 10 }}
        visible={userModalVisible}
        onCancel={hideUserSelectModal}
        footer={[
          <Button key="submit" type="primary" onClick={hideUserSelectModal}>
            Ok
          </Button>,
        ]}
      >
        <Row justify="spaced-around" gutter={[32, 32]}>
          <Col lg={24} md={24}>
            <div style={{ width: "100%", height: "100%" }}>
              <Table
                rowSelection={rowSelection}
                dataSource={activeUsers}
                columns={activeUserscolumns}
                style={{}}
                size="small"
              />
            </div>
          </Col>
        </Row>
      </Modal>

      <Modal
        width={1000}
        title="Preview DMs"
        style={{ top: 40, right: 10 }}
        visible={previewModalVisible}
        onCancel={hidePreviewModal}
        footer={[
          <Tooltip title="Check all the messages before sending!">
            <Button
              key="submit"
              type="primary"
              onClick={scheduleDMs}
              loading={isSending}
            >
              Send
            </Button>
          </Tooltip>,
        ]}
      >
        {sendNow ? (
          <span>
            You are about to send the following direct messages <b>now</b>{" "}
            (Note: Actual message sent will be delayed by 2 minutes)
          </span>
        ) : (
          <span>
            You are about to send the following direct messages on{" "}
            <b> {moment(dateTimeObj).format("YYYY-MM-DD")} </b> at{" "}
            <b> {moment(dateTimeObj).format("HH:mm")} </b>{" "}
          </span>
        )}
        <Row>
          <div style={{ width: "100%", height: "100%" }}>
            <Table
              dataSource={previewMessages}
              columns={previewMessagesColumns}
              style={{}}
            />
          </div>
        </Row>
      </Modal>
    </div>
  );
};

// props.sendNow (boolean): if true, set scheduled time to now, else show datepicker
// props.closeModal should be a function in the parent that closes this modal
// SendDM.protoTypes = {
//   closeModal: PropTypes.func.isRequired,
//   sendNow: PropTypes.boolean.isRequired,
// };

export default SendDM;
